/** Array/series utilities — todas puras. */

/**
 * Soma dos valores de um Map<isoDate, number> dentro de um range [from, to].
 * Datas ausentes contam como 0.
 */
export function SumDailyInRange(dailyByDate, from, to) {
    if (!dailyByDate || !(dailyByDate instanceof Map)) return 0;
    const fromIso = typeof from === 'string' ? from : null;
    const toIso = typeof to === 'string' ? to : null;
    if (!fromIso || !toIso) return 0;
    let total = 0;
    dailyByDate.forEach((qty, iso) => {
        if (iso >= fromIso && iso <= toIso) {
            total += Number(qty || 0);
        }
    });
    return total;
}

/**
 * Maior valor (e a data) em um Map<isoDate, number> dentro do range.
 * Retorna { qty, date } com date como ISO string, ou null se tudo for 0.
 */
export function MaxDailyInRange(dailyByDate, from, to) {
    if (!dailyByDate || !(dailyByDate instanceof Map)) return null;
    let maxQty = 0;
    let maxDate = null;
    dailyByDate.forEach((qty, iso) => {
        if (iso >= from && iso <= to) {
            const v = Number(qty || 0);
            if (v > maxQty) {
                maxQty = v;
                maxDate = iso;
            }
        }
    });
    if (maxQty <= 0 || !maxDate) return null;
    return { qty: maxQty, date: maxDate };
}

/**
 * Array de números (qtds) ordenado por data ASC dentro do range.
 * Datas ausentes preenchidas com 0. Garante length == DaysBetween.
 */
export function SeriesInRange(dailyByDate, from, to, enumeratedDates) {
    const dates = enumeratedDates || [];
    return dates.map((iso) => Number(dailyByDate?.get(iso) || 0));
}
